module.exports = __webpack_public_path__ + "img/e-formapp_logo_2022.339c777a.svg";